<template>
    <!-- 滑动返回上一页 -->
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="orderConfirmation">
            <!-- 顶部导航，标题，返回按钮，返回按钮名称 -->
            <van-nav-bar
                title="调整签收方量单列表"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <!-- 列表加载更多 -->
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="isUpLoading"
                    :finished="finished"
                    finished-text="没有更多了!"
                    @load="onLoad"
                >
                    <ul class="dataList">
                        <template v-for="(item, index) in orderData">
                            <li :key="index" class="dataItem">
                                <h3 class="shippingOrder">
                                    <span class="iconfont icondanjubianhao">运输单号:{{ item.delivery_receipt_number }}</span>
                                </h3>
                                <ul class="cellList">
                                    <li class="cellItem">
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>发货方量:{{ item.deliver_volume }}m³</span>
                                        </p>
                                    </li>
                                    <li class="cellItem">
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>签收方量:{{ item.sign_volume }}m³</span>
                                        </p>
                                        <p class="afterChange">
                                            <span>调整后签收方量:{{ item.adjusted_sign_volume }}m³</span>
                                        </p>
                                    </li>
                                    <li class="cellItem inLine">
                                        <p class="inLine">
                                            <img src="@/assets/images/icons/icon_18.png" alt="">
                                            <span>车号:{{ item.car_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3.png" alt="">
                                            <span>驾驶员:{{ item.sjxm }}</span>
                                        </p>
                                    </li>
                                    <li class="cellItem">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>发货时间:{{ item.deliver_time }}</span>
                                        </p>
                                    </li>
                                    <li class="cellItem">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>工程名称:{{ item.engineering_name }}</span>
                                        </p>
                                    </li>
                                    <li class="cellItem">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                            <span>施工部位:{{ item.place_name }}</span>
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </van-pull-refresh>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 调整签收方量单列表
    name: 'change-invoice-number',
    components: {},
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 上拉索引
            count: 1,
            // 列表总条数
            total: 0,
            // 记录上拉还是下拉
            slidingDirection: '',
            // 列表数据
            orderData: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/invoiceCheck' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/invoiceCheck' });
        },
        // 下拉刷新
        onRefresh() {
            this.slidingDirection = 'down';
            this.count = 1;
            this.getOrderData();
            this.count++;
        },
        // 上拉加载更多
        onLoad() {
            this.slidingDirection = 'up';
            this.getOrderData();
            this.count++;
        },
        // 拉取发货单数据
        getOrderData() {
            const params = {
                station_id: this.$route.query.station_id,
                checked_date: this.$route.query.checked_date,
                query_type: '1',
                pageindex: this.count,
                pagesize: '5',
            };
            this.$axios
                .get('/interfaceApi/sale/accounts/get_scan_day_type', { params: params })
                .then(res => {
                    this.total = res.total;
                    if (this.orderData.length < 1 || this.slidingDirection === 'down') {
                        this.orderData = res.rows;
                        this.finished = false;
                    } else {
                        res.rows.forEach(item => {
                            this.orderData.push(item);
                        });
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                    if (this.orderData.length === this.total) {
                        this.finished = true;
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.finished = true;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 日期格式化
        timeFormat(date, type) {
            type = type || '-';
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            const day = date.getDate();
            if ( month < 10 ) {
                month = '0' + month;
            }
            return '' + year + type + month + type + day;
        },
    },
};
</script>
<style lang="stylus" scoped>

.orderConfirmation
    height 100%
    .van-pull-refresh
        height calc(100% - 45rpx)
        background #f0f0f0
        overflow-y auto
        .dataList
            .dataItem
                padding 15rpx 0 1px 13rpx
                margin 15rpx
                background #fff
                .shippingOrder
                    display flex
                    align-items center
                    margin-bottom 15rpx
                    vertical-align middles
                    span
                        font-size: 18rpx
                        color: #061F3E
                    .icondanjubianhao
                        &:before
                            color #3495FB
                .cellList
                    .cellItem
                        display flex
                        align-items center
                        p
                            display flex
                            align-items center
                            margin-bottom 15rpx
                            vertical-align middles
                            img,span
                                display inline-block
                                height 16rpx
                                line-height 16rpx
                            img
                                width 16rpx
                                margin-right 8rpx
                            span
                                font-size 14rpx
                                color #666
                        .inLine
                            width 180rpx
                        .afterChange
                            height: 24rpx;
                            padding 0 10rpx
                            margin-left 5rpx
                            background: #FFFBE6
                            border: 1px solid #FFE99F
                            span
                                font-size: 14rpx
                                color: #FAAF19

</style>
